import { Flex } from '@aloft/toolkit-sui';

import { useEffect } from 'react';

import { useTkv2ReferenceBarEvents } from '../../components/ReferenceBar/useTkv2ReferenceBarEvents.ts';
import { selectHoveredOrderDetailsFieldKey } from '../../redux/features/selectors/referenceBarUISelectors.ts';
import { selectFocusedOrderDetailsFieldKey } from '../../redux/features/selectors/uiSelectors.ts';
import { useAppDispatch, useAppSelector } from '../../redux/hooks.ts';
import { focusOrderDetailsField, scrollOrderDetailsFieldIntoView } from './orderDetailsFieldFocus.ts';
import {
  setReferenceViewOpen,
  setSelectedDataSheet,
} from '../../redux/features/referenceBarUISlice.ts';
import { OrderDetails } from './ModuleComponents/OrderDetails.tsx';
import { SubjectPropertyDetails } from './ModuleComponents/SubjectPropertyDetails.tsx';

export const OrderDetailsModule = () => {
  const dispatch = useAppDispatch();
  const focusedOrderDetailsFieldKey = useAppSelector(selectFocusedOrderDetailsFieldKey);
  const hoveredOrderDetailsFieldKey = useAppSelector(selectHoveredOrderDetailsFieldKey);

  useEffect(() => {
    dispatch(setSelectedDataSheet('client-information'));
    dispatch(setReferenceViewOpen(true));
  }, []);

  useEffect(() => {
    if (!focusedOrderDetailsFieldKey) {
      return;
    }
    focusOrderDetailsField(focusedOrderDetailsFieldKey);
  }, [focusedOrderDetailsFieldKey]);

  useEffect(() => {
    if (!hoveredOrderDetailsFieldKey || hoveredOrderDetailsFieldKey === focusedOrderDetailsFieldKey) {
      return;
    }
    scrollOrderDetailsFieldIntoView(hoveredOrderDetailsFieldKey);
  }, [focusedOrderDetailsFieldKey, hoveredOrderDetailsFieldKey]);

  return (
    <Flex {...useTkv2ReferenceBarEvents()} width="100%" gap={2}>
      <Flex flexDirection="column" width="100%" gap={2} backgroundColor="surface1" margin="15px">
        <OrderDetails />
        <SubjectPropertyDetails />
      </Flex>
    </Flex>
  );
};
